import { WhyCompWrapper } from "../../styles/StyledComponents/WhyCompWrapper";
import assests from "../../ui/assests";
import CommonHeading from "../CommonHeading/CommonHeading";

const WhyComp = () => {
  const detailsList = [
    {
      name: "Work on Innovative Projects",
      details:
        "Be part of meaningful, real-world projects that challenge you and help build your portfolio with impactful digital solutions.",
    },
    {
      name: "Flexible Work Environment",
      details:
        "Enjoy the freedom to work remotely, on-site, or in a hybrid setup—designed to fit your lifestyle and maximize productivity.",
    },
    {
      name: "Creativity & Continuous Learning",
      details:
        "Bring your ideas to the table and expand your knowledge with hands-on experience, learning sessions, and experimentation.",
    },
    {
      name: "Supportive Team Culture",
      details:
        "Work in a collaborative space where feedback is encouraged, teamwork is valued, and everyone’s contribution matters.",
    },
    {
      name: "Skill Development & Mentorship",
      details:
        "Grow your skills with guidance from experienced professionals and access to resources that help you stay ahead.",
    },
    {
      name: "Career Growth Opportunities",
      details:
        "Advance your career in web development, SEO, and digital marketing with clear paths for growth and performance-driven recognition.",
    },
  ];

  return (
    <WhyCompWrapper className="cmn_gap">
      <div className="container">
        <CommonHeading
          className="whySec_heading"
          isPrimary
          title="Why Work With Us"
          paratext="At EMIIT, we offer more than just a job—we offer a place to grow. Join a creative, collaborative team working on real-world projects in web design, development, SEO, and digital marketing. With flexible work options, continuous learning, and a supportive culture, EMIIT is where talent thrives and ideas come to life."
        />
        <div className="working_details_div">
          <figure className="whySec_bg">
            <img src={assests.bgImg01} alt="bgImg01" />
          </figure>
          <div className="row workDetails_row">
            {detailsList?.map((data, index) => (
              <div className="workDetails_col" key={index}>
                <div className="workDetails_col_inner">
                  <h3>{data?.name}</h3>
                  <p>{data?.details}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </WhyCompWrapper>
  );
};

export default WhyComp;
